module.exports = __webpack_public_path__ + "assets/media/email.cdfdc5ba.svg";